function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M151.066 83.5352C150.986 83.5352 150.905 83.5084 150.851 83.4279C150.771 83.3207 150.798 83.1598 150.905 83.0525C150.932 83.0257 154.338 80.478 159.004 82.7575C159.138 82.8111 159.192 82.972 159.138 83.1061C159.085 83.2402 158.924 83.2938 158.79 83.2402C154.418 81.1216 151.361 83.4011 151.227 83.4816C151.2 83.5084 151.12 83.5352 151.066 83.5352Z",
  fill: "#E04E39"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M225.897 355C129.388 304.633 96.4842 252.44 86 217H147.991C147.642 222.558 145.975 228.008 143.179 232.84C141.808 235.096 141.082 237.727 141.082 240.412C141.082 248.52 147.669 255.098 155.787 255.098C163.906 255.098 170.492 248.52 170.492 240.412C170.492 237.727 169.766 235.096 168.368 232.814C165.572 228.008 163.932 222.558 163.583 217H225.924V274.67L227.08 274.563C232.617 274.079 238.074 272.334 242.86 269.569C244.849 268.361 247.08 267.743 249.392 267.743C256.328 267.743 262 273.381 262 280.335C262 287.262 256.355 292.927 249.392 292.927C247.08 292.927 244.822 292.309 242.86 291.101C238.048 288.309 232.59 286.591 227.053 286.081L225.897 285.973V355Z",
  fill: "#623B2A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M227.228 288.012C232.109 288.602 236.721 290.158 240.985 292.625C243.238 293.992 245.866 294.717 248.548 294.717C256.647 294.717 263.217 288.146 263.217 280.047C263.217 271.948 256.647 265.378 248.548 265.378C245.866 265.378 243.238 266.102 240.959 267.496C236.721 269.964 232.109 271.492 227.228 272.082V216.784H300.441L300.468 215.765C300.709 208.604 298.939 201.551 295.345 195.356C294.139 193.372 293.522 191.146 293.522 188.84C293.522 181.921 299.153 176.262 306.099 176.262C313.018 176.262 318.677 181.894 318.677 188.84C318.677 191.146 318.06 193.399 316.853 195.356C313.26 201.578 311.49 208.631 311.704 215.792L311.731 216.811H366.788C356.329 252.21 323.504 304.344 227.228 354.655V288.012Z",
  fill: "#2C2A29"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M155.653 253C148.795 253 143.187 247.372 143.187 240.432C143.187 238.127 143.798 235.876 144.994 233.92C148.131 228.48 149.885 222.289 150.098 216.018L150.124 214.946H86.0667C83.3821 205.085 82 195.196 82 185.495C82 162.958 89.0703 141.867 101.935 126.137C115.172 109.924 133.485 101 153.5 101C178.033 101 196.214 111.317 207.112 119.973C217.903 128.522 223.937 137.205 224.973 138.759V165.37C220.588 164.673 216.415 163.199 212.561 160.948C210.328 159.581 207.723 158.858 205.065 158.858C197.038 158.858 190.526 165.423 190.526 173.516C190.526 181.609 197.038 188.175 205.065 188.175C207.723 188.175 210.328 187.451 212.587 186.058C216.441 183.807 220.614 182.333 225 181.636V214.946H161.208L161.235 216.018C161.447 222.289 163.202 228.48 166.312 233.893C167.508 235.876 168.119 238.1 168.119 240.405C168.119 247.372 162.537 253 155.653 253Z",
  fill: "#E04E39"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M153.346 96.112C150.396 96.5947 150.557 97.0774 150.182 97.1311C149.726 97.1847 144.389 94.5297 144.389 94.5297C144.389 94.5297 128.593 86.7526 127.762 86.3235L116.364 72.0295L107.595 76.079C107.595 76.079 120.414 91.2848 121.218 91.9552C122.023 92.6257 144.657 100.537 146.615 101.288C146.615 101.288 148.6 103.085 149.887 104.184C151.174 105.284 152.89 105.713 153.293 105.954C153.346 105.981 154.768 106.732 156.779 107.161C158.495 107.536 157.074 106.356 157.074 106.356C157.074 106.356 154.017 105.069 154.178 104.828C154.285 104.64 155.921 105.445 157.825 105.874C158.308 105.981 158.79 106.088 159.246 106.196C160.426 106.437 160.936 105.793 159.756 105.311C159.353 105.15 158.656 104.881 158.12 104.774C157.557 104.667 157.074 104.372 156.618 104.184C155.706 103.836 155.036 103.594 155.089 103.567C155.143 103.514 155.009 103.326 155.519 103.433C156.135 103.567 157.423 104.131 158.361 104.238C158.898 104.291 159.997 104.506 159.997 104.506C159.997 104.506 161.955 104.694 161.982 104.426C162.008 103.836 160.802 103.487 160.078 103.514C159.622 103.272 158.442 103.111 158.442 103.111C158.442 103.111 156.162 102.226 156.296 101.878C156.35 101.744 157.718 101.958 159.193 102.039C160.748 102.146 161.848 102.146 161.928 101.851C162.062 101.368 160.828 101.207 160.828 101.207C160.828 101.207 159.756 101.046 159.38 100.966C158.978 100.859 157.744 100.483 157.744 100.483C157.744 100.483 153.561 98.9547 153.722 98.6329C153.883 98.3379 154.553 97.6942 154.848 97.6942C155.143 97.6942 155.679 97.9893 155.974 97.9893C156.269 97.9893 156.913 97.9356 156.94 97.5602C156.994 97.1847 155.358 96.4338 155.358 96.4338C155.358 96.4338 154.204 95.9779 153.346 96.112Z",
  fill: "#F8A492"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M124.329 80.8528C124.329 80.8528 121.486 83.4274 120.306 84.2855C119.314 84.9828 114.54 87.2891 114.54 87.2891C114.54 87.2891 109.767 80.0215 107.702 76.3743C105.181 71.9493 103.411 65.3789 104.028 65.1912C105.717 64.6817 108.024 64.3867 110.142 65.3521C117.49 68.7043 124.329 80.8528 124.329 80.8528Z",
  fill: "#C39367"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M150.584 99.9198C151.844 100.108 153.132 99.8662 153.695 98.713C153.829 100.081 151.764 100.751 150.584 99.9198Z",
  fill: "#FE875E"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M77.8 191.798L77.4782 197.376C77.3709 198.073 76.915 199.843 76.915 200.46C76.915 202.874 87.669 198.422 85.2554 197.349C85.0409 197.242 83.8877 196.518 83.8341 195.687C83.7268 194.426 83.4318 191.852 83.4318 191.852L77.8 191.798Z",
  fill: "#F7A491"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M85.2285 197.322C85.2285 197.322 82.7077 198.073 81.4204 198.234C80.1332 198.422 78.4168 196.867 77.505 197.296C76.4859 197.752 76.5395 201.908 76.5395 201.908C76.5395 201.908 90.0558 203.088 93.8639 201.855C95.3657 201.399 90.3776 199.039 85.2285 197.322Z",
  fill: "#2C2A29"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5295 191.449L60.2077 197.028C60.1005 197.725 59.6445 199.495 59.6445 200.112C59.6445 202.525 70.3985 198.074 67.9849 197.001C67.7704 196.894 66.2954 195.633 66.2149 194.802C66.1076 193.541 66.1613 191.53 66.1613 191.53L60.5295 191.449Z",
  fill: "#F7A491"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M67.9579 197.001C67.9579 197.001 65.437 197.752 64.1498 197.913C62.8625 198.1 61.1462 196.545 60.2344 196.974C59.2153 197.43 59.1885 201.587 59.1885 201.587C59.1885 201.587 72.6242 202.15 76.5933 201.533C78.1487 201.318 73.1069 198.717 67.9579 197.001Z",
  fill: "#2C2A29"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M62.9701 103.594C62.9701 103.594 61.1465 112.981 61.8974 120.114C62.6483 127.248 62.7019 152.537 62.7019 152.537L59.8593 193.032L66.5905 193.193C66.5905 193.193 74.5555 152.725 74.4214 153.771C74.2605 154.817 77.1032 125.263 77.1032 125.263L67.6096 102.709L62.9701 103.594Z",
  fill: "#D3D2D2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M65.5175 97.5337C65.5175 97.5337 57.2577 106.196 60.3417 115.663C61.5753 119.471 73.0802 155.782 73.2143 158.759C73.3752 161.736 77.1029 194.534 77.1029 194.534L84.9069 194.293L86.5964 157.82L84.3705 108.663L79.6237 100.376L65.5175 97.5337Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M115.586 69.4279C112.878 66.4243 107.005 62.053 107.005 62.053C107.005 62.053 103.491 59.0762 102.07 58.5667C99.9782 57.8426 96.3578 55.9117 91.1551 63.7962C87.4274 69.4279 63.9082 98.579 60.0464 99.5712L85.2552 111.586C85.9525 105.847 98.396 94.9854 100.193 92.974C104.215 88.4418 118.161 72.2706 115.586 69.4279Z",
  fill: "#CAA480"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M114.406 57.1194L106.549 61.7053C106.549 61.7053 106.334 68.3829 108.882 70.1261C111.027 71.5742 112.663 68.0879 112.663 68.0879C112.663 68.0879 115.586 64.0652 117.812 62.8048C120.065 61.5175 114.406 57.1194 114.406 57.1194Z",
  fill: "#F7A491"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M113.093 60.0691C113.388 61.4637 114.085 63.475 115.131 65.1377C115.989 64.1991 116.981 63.2873 117.839 62.8046C118.858 62.2146 118.215 60.9809 117.222 59.801C115.801 58.326 114.433 57.146 114.433 57.146L112.932 58.031C112.824 58.5673 113.012 59.5864 113.093 60.0691Z",
  fill: "#F47458"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M118.51 45.6418C118.376 45.4809 111.912 53.4994 112.717 57.2539C113.522 61.0084 117.41 64.4411 120.119 63.5025C123.122 62.4566 128.7 53.0167 126.689 48.4577C124.705 43.845 118.51 45.6418 118.51 45.6418Z",
  fill: "#F7A491"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M125.563 43.0938C122.747 41.5384 118.161 41.0825 114.728 42.8793C110.518 45.0784 109.552 50.6297 110.866 54.0087C112.18 57.3878 110.679 59.2918 110.679 59.2918L112.905 57.9778C112.905 57.9778 114.219 55.9396 114.38 54.3305C114.54 52.7215 116.927 52.9896 118.08 52.2655C118.965 51.7024 120.119 49.8519 121.54 48.9133C121.54 48.9133 125.16 48.4574 126.957 49.4765C130.041 51.166 129.612 45.3465 125.563 43.0938Z",
  fill: "#2C2A29"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M138.033 107.912C134.949 107.536 134.949 107.778 134.573 107.724C134.117 107.643 129.317 103.54 129.317 103.54C129.317 103.54 115.103 91.4991 114.379 90.8287L106.575 73.6116L96.2773 75.1402C96.2773 75.1402 105.878 95.3877 106.549 96.2727C107.219 97.1577 128.298 109.44 130.095 110.728C130.095 110.728 131.704 113.061 132.75 114.482C133.796 115.903 135.431 116.815 135.807 117.164C135.861 117.217 137.121 118.344 139.052 119.336C140.715 120.194 139.508 118.639 139.508 118.639C139.508 118.639 136.719 116.52 136.906 116.332C137.067 116.198 138.516 117.432 140.339 118.397C140.795 118.639 141.278 118.88 141.707 119.095C142.833 119.658 143.504 119.175 142.404 118.371C142.029 118.102 141.385 117.647 140.875 117.405C140.339 117.137 139.91 116.708 139.481 116.413C138.65 115.823 138.06 115.421 138.113 115.421C138.167 115.394 138.033 115.126 138.542 115.367C139.159 115.662 140.312 116.574 141.224 116.949C141.76 117.164 142.833 117.673 142.833 117.673C142.833 117.673 144.415 117.888 144.469 117.781C144.791 117.298 143.852 116.896 143.101 116.708C142.672 116.332 141.546 115.85 141.546 115.85C141.546 115.85 139.454 114.348 139.669 114.053C139.749 113.946 140.983 114.777 142.485 115.34C144.201 115.984 145.032 115.635 145.193 115.367C145.435 114.938 144.362 114.697 144.362 114.697C144.362 114.697 142.914 114.348 142.565 114.16C142.163 113.946 137.55 110.459 137.765 110.191C137.979 109.923 138.703 109.923 138.998 110.03C139.293 110.111 139.83 110.325 140.125 110.406C140.42 110.486 140.929 110.138 141.063 109.789C141.197 109.44 140.071 108.823 140.071 108.823C140.071 108.823 138.918 108.019 138.033 107.912Z",
  fill: "#F8A492"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M97.9133 83.5078C97.9133 83.5078 100.863 82.5691 102.767 81.711C104.028 81.121 109.579 78.3855 109.579 78.3855C109.579 78.3855 107.192 68.3288 105.583 64.7084C99.6564 51.4336 92.8983 60.5785 91.9865 62.7239C89.9484 67.4707 97.9133 83.5078 97.9133 83.5078Z",
  fill: "#C39367"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M313.335 215C313.308 208.592 314.97 202.292 318.187 196.715C319.555 194.463 320.278 191.835 320.278 189.154C320.278 181.057 313.71 174.489 305.614 174.489C297.545 174.489 290.95 181.057 290.95 189.154C290.95 191.835 291.674 194.463 293.068 196.742C296.285 202.292 297.947 208.592 297.92 215H226.771V179.288L225.591 179.422C220.444 180.039 215.565 181.674 211.088 184.275C209.104 185.481 206.879 186.098 204.573 186.098C197.657 186.098 192 180.468 192 173.524C192 166.606 197.63 160.949 204.573 160.949C206.879 160.949 209.131 161.566 211.088 162.772C215.591 165.373 220.471 167.008 225.618 167.652L226.797 167.786V138.777C227.843 137.222 233.928 128.535 244.813 119.982C255.804 111.322 274.141 101 298.885 101C319.072 101 337.543 109.928 350.894 126.149C363.842 141.887 371 162.987 371 185.535C371 195.24 369.633 205.16 366.898 215H313.335Z",
  fill: "#C39367"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M367.835 262.195H346.514C345.468 262.195 344.61 261.337 344.61 260.291C344.61 259.245 345.468 258.387 346.514 258.387H367.835C368.88 258.387 369.739 259.245 369.739 260.291C369.739 261.337 368.88 262.195 367.835 262.195Z",
  fill: "#DE7964"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M369.927 265.199H344.396C343.35 265.199 342.492 264.34 342.492 263.295C342.492 262.249 343.35 261.391 344.396 261.391H369.927C370.973 261.391 371.831 262.249 371.831 263.295C371.831 264.34 370.973 265.199 369.927 265.199Z",
  fill: "#E04E39"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M295.105 392.53C295.105 392.53 293.147 394.461 293.094 395.185C293.04 395.909 292.933 403.526 293.71 404.25C294.515 404.974 296.875 405.457 296.124 406.261C295.561 406.878 291.136 406.744 288.24 406.583C287.381 406.529 286.309 399.637 285.987 398.645C285.504 397.17 283.734 393.979 284.163 392.959C284.378 392.45 285.987 391.324 287.462 390.358C288.99 389.339 290.465 387.113 290.465 387.113L295.105 392.53Z",
  fill: "#F7A491"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M321.386 397.303L319.616 402.345C319.482 403.15 318.973 405.107 318.973 405.831C318.973 408.567 331.094 403.525 328.386 402.318C328.144 402.211 327.367 401.326 327.286 400.414C327.152 398.993 328.305 397.196 328.305 397.196L321.386 397.303Z",
  fill: "#F7A491"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M338.094 301.725L342.492 313.096C342.492 313.096 345.361 340.209 343.699 356.46C343.001 363.245 327.903 399.583 327.903 399.583L320.394 398.511L330.424 355.468L326.723 339.002L321.493 306.472L338.094 301.725Z",
  fill: "#2C2A29"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M317.444 302.315L313.689 314.973L307.977 353.161L288.615 388.883C288.615 388.883 291.538 393.361 294.649 394.059L322.137 357.962L337.021 312.774L336.512 302.744L317.444 302.315Z",
  fill: "#2C2A29"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M375.21 281.236C372.957 282.255 373.199 282.684 372.904 282.791C372.555 282.925 367.808 281.423 367.808 281.423C367.808 281.423 353.809 277.079 353.058 276.838L341.285 265.467L335.09 270.991C335.09 270.991 348.151 282.925 348.928 283.408C349.706 283.891 369.176 287.028 370.865 287.377C370.865 287.377 372.796 288.718 374.003 289.496C375.237 290.273 376.685 290.354 377.06 290.515C377.114 290.541 378.374 290.971 380.064 290.997C381.512 291.024 380.144 290.193 380.144 290.193C380.144 290.193 377.489 289.549 377.543 289.308C377.597 289.12 379.045 289.576 380.627 289.603C381.029 289.603 381.432 289.63 381.807 289.63C382.773 289.656 383.067 288.906 382.048 288.691C381.7 288.611 381.083 288.503 380.654 288.503C380.171 288.503 379.742 288.316 379.34 288.235C378.562 288.074 377.972 287.994 377.999 287.94C378.026 287.887 377.892 287.726 378.321 287.726C378.83 287.726 379.957 288.021 380.734 287.94C381.163 287.887 382.075 287.86 382.075 287.86C382.075 287.86 383.55 287.618 383.55 287.511C383.604 286.948 382.504 286.733 381.914 286.894C381.512 286.76 380.547 286.814 380.547 286.814C380.547 286.814 378.562 286.412 378.616 286.063C378.643 285.768 383.523 285.661 383.523 285.071C383.523 284.588 382.075 284.561 382.075 284.561C382.075 284.561 381.19 284.615 380.895 284.615C380.547 284.615 379.501 284.481 379.501 284.481C379.501 284.481 375.907 283.837 375.961 283.515C376.014 283.193 376.443 282.442 376.685 282.389C376.926 282.335 377.382 282.523 377.623 282.442C377.865 282.389 378.133 282.067 378.079 281.718C378.053 281.37 376.819 281.102 376.819 281.102C376.819 281.102 375.88 280.941 375.21 281.236Z",
  fill: "#F8A492"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M345.522 268.363L339.622 276.355C339.622 276.355 334.42 270.107 332.086 266.969C329.244 263.161 326.133 257.904 326.589 257.609C327.903 256.805 329.512 255.947 331.389 256.456C337.96 258.199 345.522 268.363 345.522 268.363Z",
  fill: "#E28B7E"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M287.542 390.277C287.542 390.277 291.672 402.962 293.442 403.579C293.925 403.74 296.553 404.41 296.982 405.429C296.982 405.456 297.009 405.483 297.009 405.51C297.143 406.154 296.607 406.744 295.963 406.744H287.569C287.569 406.744 286.362 401.058 285.906 398.537C285.906 398.537 283.412 392.423 283.68 391.86C283.949 391.323 287.542 390.277 287.542 390.277Z",
  fill: "#7C5D50"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M318.275 406.744L319.616 402.292C319.616 402.292 322.566 403.552 324.014 403.338C325.463 403.123 328.305 402.292 328.305 402.292C334.125 404.223 338.898 405.161 338.013 406.744H318.275Z",
  fill: "#7C5D50"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M373.413 285.124C374.485 285.098 375.344 284.615 375.987 283.569C375.773 285.017 374.378 285.634 373.413 285.124Z",
  fill: "#FE875E"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M318.946 256.242C318.946 256.242 311.919 256.993 309.559 257.797C307.602 258.495 304.947 264.904 304.947 264.904C304.947 264.904 315.593 295.718 315.191 301.215C314.762 306.713 313.582 314.866 313.582 314.866C313.582 314.866 334.554 316.18 342.519 313.042C342.519 313.042 339.998 300.572 339.998 297.3C339.998 294.028 338.576 261.284 337.584 259.567C336.592 257.851 334.554 256.885 330.719 256.027C326.884 255.223 318.946 256.242 318.946 256.242Z",
  fill: "#E04E39"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M320.34 247.07L318.946 256.241C318.946 256.241 323.156 261.095 326.213 260.157C328.761 259.352 328.09 255.759 328.09 255.759C328.09 255.759 326.696 250.583 327.125 247.981C327.527 245.38 320.34 247.07 320.34 247.07Z",
  fill: "#F7A491"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M327.098 247.981C327.527 245.38 320.313 247.07 320.313 247.07L320.206 247.82C320.42 248.33 320.662 248.759 320.984 249.108C322.593 250.824 325.114 251.843 327.259 251.924C327.071 250.529 326.937 249.054 327.098 247.981Z",
  fill: "#FE875E"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M319.16 234.117C318.946 234.037 317.524 244.549 320.233 247.445C322.942 250.342 328.198 251.28 330.102 249.001C332.194 246.48 332.086 235.19 327.876 232.213C323.666 229.236 319.16 234.117 319.16 234.117Z",
  fill: "#F7A491"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M326.267 226.581C323.022 227.251 320.903 229.209 320.126 230.067C318.651 230.228 316.639 231.059 314.574 234.465C312.027 238.649 313.904 243.288 316.881 245.568C319.857 247.847 319.804 250.476 319.804 250.476L320.26 249.108C320.608 248.089 320.742 246.989 320.635 245.89C320.555 245.246 320.421 244.549 320.152 243.959C319.428 242.43 321.681 241.438 322.325 240.151C322.807 239.185 322.834 236.959 323.585 235.324L324.497 234.09C324.497 234.09 326.589 232.454 328.654 232.91C330.745 233.419 330.45 225.75 326.267 226.581Z",
  fill: "#7C5D50"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M322.191 242.055C322.217 243.343 321.627 244.389 320.876 244.389C320.126 244.389 319.509 243.37 319.482 242.082C319.455 240.795 320.045 239.749 320.796 239.749C321.547 239.749 322.191 240.768 322.191 242.055Z",
  fill: "#F7A491"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M331.72 300.739H374.066V263.998H331.72V300.739Z",
  fill: "#7C5D50"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M358.056 300.739H394.797V263.998H358.056V300.739Z",
  fill: "#977F75"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M357.349 299.955C355.177 299.338 330.424 292.982 329.485 292.365C328.546 291.748 313.26 277.455 313.26 277.455L322.03 272.815L335.734 286.304C336.672 286.707 354.211 293.358 354.211 293.358C354.211 293.358 359.575 295.557 360.031 295.449C360.433 295.369 360.755 295.02 363.812 294.35C364.697 294.162 365.957 294.538 365.957 294.538C365.957 294.538 367.486 295.02 367.486 295.369C367.486 295.744 367.111 296.013 366.789 296.039C366.467 296.066 365.877 295.798 365.582 295.825C365.26 295.852 364.617 296.522 364.509 296.844C364.429 297.032 368.773 300.196 368.988 300.625C369.095 300.733 374.298 300.384 374.083 300.706C374.083 301.242 373.466 301.081 373.466 301.162C373.386 302.583 366.011 303.656 365.502 303.495C364.617 303.28 357.349 299.955 357.349 299.955Z",
  fill: "#F8A492"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M317.98 284.052L328.01 277.481C328.01 277.481 316.398 259.862 312.429 258.038C309.694 256.778 306.288 258.682 304.974 263.321C303.499 268.336 317.98 284.052 317.98 284.052Z",
  fill: "#DE7964"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M391.14 272.306L389.45 273.942V264.421C389.45 263.429 388.646 262.624 387.653 262.624H372.769C371.777 262.624 370.973 263.429 370.973 264.421V275.497L369.149 272.332L362.874 274.156C362.874 274.156 367.915 283.757 370.999 285.312C375.103 287.404 385.32 287.35 389.45 285.312C391.971 284.079 396.262 276.382 396.262 276.382L391.14 272.306Z",
  fill: "#EDFDFC"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M385.481 286.438C385.186 283.14 382.96 280.565 380.278 280.565C377.57 280.565 375.344 283.14 375.075 286.465C378.267 287.002 382.263 286.975 385.481 286.438Z",
  fill: "#D3D2D2"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M296.821 18.7435C295.293 21.318 292.584 21.2107 289.688 21.9348C287.73 22.4175 286.523 25.6357 286.711 28.0493C287.194 34.1906 282.367 33.1447 278.478 35.6924C269.172 41.78 275.179 57.7099 285.343 58.7289C287.382 58.9435 289.688 58.5949 291.485 57.6026C292.933 56.7981 293.952 55.7522 295.588 55.1622C299.02 53.9554 302.829 53.5263 305.564 50.8981C309.479 47.1436 306.235 45.2932 307.254 42.5578C308.273 39.8223 312.617 41.1901 313.449 35.5047C314.334 29.3634 313.368 24.0802 311.089 21.023C307.334 15.9812 300.764 15.6326 298.35 17.1612C297.653 17.6708 297.143 18.1803 296.821 18.7435Z",
  fill: "url(#paint0_linear_100_2)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M339.488 30.275C339.14 29.5241 335.922 31.7768 335.198 31.3477C334.474 30.9187 338.067 27.2982 337.719 26.6546C337.048 25.5014 333.535 30.3823 333.186 29.8728C332.838 29.3632 336.217 24.1337 335.01 23.8387C333.803 23.5437 332.087 29.6046 331.47 29.2291C330.853 28.8269 333.589 23.7315 332.409 22.6856C331.792 22.1224 328.869 31.9914 327.796 32.4205C326.723 32.8227 325.543 28.5319 324.524 28.6928C323.532 28.8537 327.796 36.6309 327.608 37.2209C327.394 37.8377 323.478 50.4957 321.172 54.3038C319.777 53.6334 318.436 52.963 317.122 52.3193C316.613 55.2693 316.559 58.3533 315.862 61.2229C320.341 63.2074 324.363 64.6287 325.65 64.146C329.62 62.671 331.577 43.4158 332.221 39.8222C332.864 36.2286 334.554 35.5045 335.519 33.6273C336.485 31.75 339.837 31.0527 339.488 30.275Z",
  fill: "#F48C7F"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M306.288 46.4996L299.637 53.2041C299.637 53.2041 308.407 57.9777 315.862 61.2495C316.532 58.3531 316.613 55.2691 317.122 52.3459C310.954 49.2351 306.288 46.4996 306.288 46.4996Z",
  fill: "#D3D2D2"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M347.722 120.946C350.645 124.379 352.763 127.972 352.978 128.401C353.085 128.616 353.139 129.85 353.246 130.064C357.778 133.041 362.579 132.21 366.521 131.003C363.92 129.876 360.299 128.589 359.977 128.026C359.441 127.168 356.974 124.03 354.426 118.372C352.388 120.41 350.484 120.168 347.722 120.946Z",
  fill: "#F7A491"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M353.031 128.589C352.629 130.412 352.79 134.087 353.166 134.167C353.595 134.274 368.827 136.5 370.785 134.569C371.965 133.389 369.739 132.477 366.548 131.029C362.605 132.236 353.192 129.796 353.031 128.589Z",
  fill: "#2C2A29"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M349.036 134.676C351.959 138.109 354.078 141.703 354.292 142.132C354.4 142.346 354.453 143.58 354.561 143.795C359.093 146.771 363.893 145.94 367.835 144.733C365.234 143.607 361.614 142.32 361.292 141.756C360.756 140.898 358.288 137.761 355.741 132.102C353.676 134.14 351.772 133.899 349.036 134.676Z",
  fill: "#F7A491"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M354.319 142.32C353.917 144.144 354.078 147.818 354.453 147.898C354.882 148.006 370.115 150.232 372.072 148.301C373.252 147.121 371.026 146.209 367.835 144.761C363.893 145.968 354.48 143.554 354.319 142.32Z",
  fill: "#2C2A29"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M356.464 120.785L348.553 123.52L305.912 88.1477C305.912 88.1477 316.318 88.0136 334.956 89.9176C340.534 90.5076 356.464 120.785 356.464 120.785Z",
  fill: "#51504F"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M289.902 85.2249C289.902 85.2249 288.776 88.2286 288.615 89.8376C288.159 95.1207 290.868 101.825 293.818 102.844C296.821 103.89 315.326 109.066 326.482 107.484L350.645 139.692L358.69 136.152L339.837 103.032C339.837 103.032 336.19 97.3198 333.213 95.9789C330.236 94.638 305.913 88.1481 305.913 88.1481L302.158 82.6772L289.902 85.2249Z",
  fill: "#2C2A29"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M309.56 51.8635C308.219 49.3962 306.851 47.4385 306.851 47.4385C305.457 44.9713 301.89 43.7108 301.89 43.7108C301.89 43.7108 300.683 43.7376 299.315 43.7913C299.235 44.0326 299.154 44.1935 299.047 44.2472C298.538 44.6226 295.561 44.1399 293.657 45.4272C287.247 50.9517 289.017 77.6623 289.527 86.0831L305.081 86.6463C305.081 86.6463 306.556 68.1151 310.525 63.4488C313.314 60.2306 311.544 55.5107 309.56 51.8635Z",
  fill: "#EDFDFC"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M300.764 34.6731C300.764 34.6731 299.691 42.3699 298.94 44.2203C298.189 46.0975 303.07 50.0934 307.12 51.3002C311.169 52.507 305.886 47.1703 306.047 45.1857C306.208 43.2012 306.959 33.7345 306.959 33.7345L300.764 34.6731Z",
  fill: "#F7A491"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M306.744 36.4431C306.851 34.8877 306.959 33.7345 306.959 33.7345L300.764 34.6731C300.764 34.6731 300.603 35.5849 300.442 36.8454C302.936 38.2935 305.189 37.8376 306.744 36.4431Z",
  fill: "#F47458"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M302.695 20.6208C302.695 20.6208 300.254 21.1839 298.752 23.4634C297.251 25.7698 296.205 32.5547 301.166 35.7192C306.127 38.8837 309.989 34.4051 310.043 30.0338C310.123 25.6893 309.184 19.843 302.695 20.6208Z",
  fill: "#F7A491"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M311.169 28.6931C310.74 29.739 309.909 30.4095 309.292 30.1413C308.675 29.8999 308.514 28.8272 308.943 27.7813C309.372 26.7354 310.204 26.065 310.82 26.3332C311.464 26.5745 311.598 27.6204 311.169 28.6931Z",
  fill: "#F7A491"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M298.672 29.5506C299.02 30.677 298.698 31.8033 297.948 32.0447C297.17 32.2861 296.258 31.562 295.909 30.4356C295.561 29.3093 295.883 28.1829 296.633 27.9416C297.411 27.7002 298.323 28.4243 298.672 29.5506Z",
  fill: "#F7A491"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M319.214 54.7584C319.214 54.7584 320.877 54.812 321.36 54.7584C324.095 54.4902 322.969 58.5397 322.969 58.5397C322.969 58.5397 321.628 57.2256 321.091 57.2256C320.555 57.2256 319.804 57.3597 319.804 57.3597L319.214 54.7584Z",
  fill: "#C39367"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M328.467 81.7382C328.467 81.7382 329.593 83.4814 330.853 82.7037C332.114 81.9259 334.286 80.3973 334.715 81.5505C335.117 82.7037 335.037 83.6423 334.608 83.8836C334.179 84.125 330.907 85.895 329.137 86.0023C327.367 86.1095 325.892 84.4468 325.892 84.4468L328.467 81.7382Z",
  fill: "#D1B49A"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M331.095 85.7062C331.041 84.3117 330.773 82.783 330.022 81.4958C328.091 78.1435 319.938 69.1327 318.705 68.4355C317.498 67.7382 318.356 65.0296 318.356 65.0296L313.529 62.4283L311.008 61.0605C311.008 61.0605 305.296 69.7764 304.867 70.6077C304.438 71.4391 305.215 74.1209 304.625 75.7836C304.062 77.4463 304.652 86.4571 303.821 87.4225C303.177 88.0662 302.587 88.1466 302.373 88.5489C302.292 88.7366 302.158 89.0048 302.399 89.3266C303.043 90.158 306.395 89.4607 306.395 89.4607C306.422 89.4071 307.79 87.4762 307.575 86.323C307.361 85.1966 308.031 78.4922 308.514 78.4922C308.916 78.4922 310.847 81.469 311.625 82.0589C311.705 82.1126 311.786 82.1662 311.839 82.1662C312.403 82.1662 315.969 82.9439 316.747 83.7485C316.962 83.963 317.042 84.5262 317.042 85.2235C317.042 85.7062 317.015 86.2425 316.988 86.7789C316.908 87.7712 316.774 88.7902 316.667 89.4607C317.525 89.4607 318.356 89.4607 319.214 89.4607C319.912 88.2003 321.387 87.3153 323.103 87.3153C324.712 87.3153 326.106 88.093 326.857 89.2193C328.279 89.1389 328.842 89.8361 330.049 89.7289C330.156 89.273 331.121 86.2425 331.095 85.7062Z",
  fill: "#C39367"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M320.883 55.3024C320.346 54.7929 319.596 54.5515 318.845 54.6856C318.442 54.7392 317.879 54.7929 317.075 54.7124C315.305 54.5515 313.481 54.6856 312.328 55.8388C311.175 56.9919 311.041 61.0683 312.328 62.9991C313.615 64.93 317.262 65.4128 317.584 66.2709C317.906 67.1559 321.071 67.5582 321.527 66.4855C321.527 66.4855 321.875 66.7268 322.358 66.5659C323.538 66.2441 323.967 65.0641 323.565 63.8037C323.136 62.5432 321.366 59.9687 321.687 57.6356C321.848 56.5629 321.392 55.8119 320.883 55.3024Z",
  fill: "#D1B49A"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M318.946 63.0186C318.731 63.2332 318.731 63.555 318.919 63.7964C319.294 64.2255 319.938 64.9495 320.421 65.2177C321.118 65.62 321.788 63.9036 321.788 63.1527C321.788 62.4018 320.179 61.7582 318.946 63.0186Z",
  fill: "white"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M312.497 75.2745C312.471 74.899 312.176 74.604 311.8 74.6308C309.923 74.7381 308.609 76.4545 308.877 78.3317C308.877 78.439 308.877 78.5195 308.877 78.5999C308.797 78.9217 308.26 80.0481 307.643 81.1744C308.77 81.4694 309.896 81.7376 311.022 82.0326C311.854 80.6112 312.658 79.2704 312.658 79.2704L312.497 75.2745Z",
  fill: "#D1B49A"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M311.785 84.0434C311.785 84.0434 310.498 87.8784 310.15 89.3534C311.195 89.9434 311.812 88.7902 314.145 89.4338C314.199 88.9779 315.03 86.1352 315.03 85.438C315.03 85.0893 316.076 83.5071 316.908 82.0857C316.961 81.9785 316.908 81.8444 316.8 81.8176C315.781 81.5226 314.467 81.013 313.448 80.718C313.314 80.6912 313.18 80.7448 313.126 80.8521C312.402 82.2198 311.785 84.0434 311.785 84.0434Z",
  fill: "#D1B49A"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M307.715 88.9783C307.956 88.442 308.707 87.7983 309.807 87.7983C310.906 87.7983 312.65 89.4342 312.65 89.4342C312.65 89.4342 312.14 89.9438 310.692 89.9438C309.297 89.9438 307.232 90.051 307.715 88.9783Z",
  fill: "#D1B49A"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M315.674 88.7374C315.916 88.201 316.667 87.5574 317.766 87.5574C318.168 87.5574 318.678 87.7987 319.161 88.0669C319.912 88.5228 319.59 89.7028 318.705 89.7028C318.678 89.7028 318.678 89.7028 318.651 89.7028C317.23 89.7028 315.165 89.8101 315.674 88.7374Z",
  fill: "#D1B49A"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M325.972 88.7374C326.267 88.201 327.179 87.5574 328.493 87.5574C329.003 87.5574 329.593 87.7987 330.156 88.0669C331.068 88.5228 330.692 89.7028 329.62 89.7028C329.593 89.7028 329.593 89.7028 329.566 89.7028C327.85 89.7028 325.382 89.8101 325.972 88.7374Z",
  fill: "#D1B49A"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M314.924 55.9928C314.414 55.4832 314.736 54.8664 315.004 54.491C313.529 54.4642 312.108 54.7055 311.142 55.671C309.989 56.8241 309.855 60.9004 311.142 62.8313C312.295 64.5477 315.353 65.1109 316.211 65.8618C317.096 64.36 315.755 63.1263 315.433 62.4022C315.111 61.705 317.015 59.935 317.23 58.5137C317.444 57.1459 315.701 56.7973 314.924 55.9928Z",
  fill: "#C39367"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M312.429 57.6497C312.429 57.6497 311.276 58.052 309.855 57.5425C308.406 57.0329 306.985 59.6074 306.985 59.6074C306.985 59.6074 308.326 62.477 309.372 63.201C310.445 63.8983 312.429 57.6497 312.429 57.6497Z",
  fill: "#D1B49A"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M330.693 79.4057C330.693 78.762 328.735 76.9116 327.796 77.2334C326.885 77.5284 323.184 79.8348 323.184 79.8348L306.798 75.973C306.798 75.973 302.668 66.5331 302.266 58.4341C298.86 58.89 296.527 59.7482 293.55 61.4109C294.971 69.1612 298.458 81.712 302.319 84.072C303.928 85.0642 323.264 82.892 323.264 82.892C323.264 82.892 327.287 83.4552 328.279 83.187C332.382 82.0338 330.693 80.6929 330.693 79.4057Z",
  fill: "#F7A491"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M302.346 49.799C301.837 47.3585 301.247 44.8913 298.592 44.1136C296.956 43.6308 295.105 44.0868 293.818 45.1595C292.263 46.4467 291.833 48.4849 291.833 50.4158C291.86 54.8139 292.155 59.373 292.96 63.7175C295.937 62.0547 300.254 62.2425 303.687 61.7866C303.982 57.8711 303.017 52.9635 302.346 49.799Z",
  fill: "#D3D2D2"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M169 35.3773C167.251 44.6038 161.706 64.0251 152.637 63.7292C152.206 51.0596 151.587 40.1654 150.699 36.7492C150.511 36.0229 150.268 35.3504 149.972 34.6779C155.624 35.1621 159.015 26.5812 160.307 20.5289C159.15 24.3755 156.539 30.5354 153.094 32.5798C151.156 33.7633 149.703 33.1716 149.165 33.0102C145.881 26.904 139.691 22.8422 136.704 19.2108C134.336 16.3057 135.87 4.6852 136.435 1C135.6 5.27699 134.712 11.5445 135.089 15.9022C135.547 20.8248 138.103 21.1476 143.917 27.7379C148.573 32.9564 150.214 35.7539 150.376 55.7401C150.026 55.8208 149.569 55.8746 149.084 55.9015C144.32 55.9822 139.934 51.3555 137.484 47.2937C139.395 50.9789 142.813 55.1483 146.796 56.4125C147.523 56.6277 148.304 56.7622 149.057 56.816C149.488 56.816 149.945 56.7891 150.349 56.7353C150.457 58.4838 150.995 92.8073 150.511 114.999C151.91 115.026 151.668 114.354 153.04 114.461C152.987 108.463 153.283 85.9749 152.664 66.2846C163.294 65.8542 167.735 46.3253 169 35.3773Z",
  fill: "#473B1E"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M130.926 5.7902C133.071 7.50655 136.263 7.07747 136.263 7.07747L128.485 0.855713C128.512 0.855713 128.78 4.07386 130.926 5.7902Z",
  fill: "url(#paint1_linear_100_2)"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M128.512 0.855337L136.289 7.07709C136.289 7.07709 135.994 3.85894 133.849 2.14259C131.703 0.453065 128.512 0.855337 128.512 0.855337Z",
  fill: "#B7D972"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M167.05 62.8319C169.812 62.7246 171.931 60.311 171.931 60.311L161.981 60.6865C161.981 60.6865 164.288 62.9392 167.05 62.8319Z",
  fill: "url(#paint2_linear_100_2)"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M161.982 60.6862L171.931 60.3108C171.931 60.3108 169.625 58.0581 166.863 58.1653C164.127 58.2726 161.982 60.6862 161.982 60.6862Z",
  fill: "#B7D972"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M169.919 52.8015C171.796 51.5947 172.306 49.0201 172.306 49.0201L165.494 53.4183C165.494 53.4183 168.042 54.0083 169.919 52.8015Z",
  fill: "url(#paint3_linear_100_2)"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M165.494 53.4185L172.306 49.0204C172.306 49.0204 169.758 48.4036 167.881 49.6372C165.977 50.844 165.494 53.4185 165.494 53.4185Z",
  fill: "#B7D972"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M160.184 52.4266C160.962 54.5184 163.376 55.5643 163.376 55.5643L160.56 47.9749C160.56 47.9749 159.433 50.3348 160.184 52.4266Z",
  fill: "url(#paint4_linear_100_2)"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M160.56 47.9746L163.376 55.5641C163.376 55.5641 164.529 53.2041 163.751 51.1123C162.973 49.0205 160.56 47.9746 160.56 47.9746Z",
  fill: "#B7D972"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M138.14 11.5824C136.451 12.7624 136.075 15.1223 136.075 15.1223L142.163 10.8851C142.163 10.8851 139.83 10.4024 138.14 11.5824Z",
  fill: "url(#paint5_linear_100_2)"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M142.163 10.8853L136.075 15.1225C136.075 15.1225 138.435 15.6052 140.098 14.4252C141.814 13.2452 142.163 10.8853 142.163 10.8853Z",
  fill: "#B7D972"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M161.391 28.5577C159.352 28.3968 157.556 30.0059 157.556 30.0059L164.957 30.569C164.957 30.569 163.429 28.7186 161.391 28.5577Z",
  fill: "url(#paint6_linear_100_2)"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M164.957 30.5693L157.556 30.0061C157.556 30.0061 159.084 31.8565 161.122 32.0174C163.161 32.1784 164.957 30.5693 164.957 30.5693Z",
  fill: "#B7D972"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M139.535 51.8353C137.497 51.6744 135.7 53.2835 135.7 53.2835L143.101 53.8466C143.101 53.8466 141.573 51.9962 139.535 51.8353Z",
  fill: "url(#paint7_linear_100_2)"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M143.101 53.8471L135.7 53.2839C135.7 53.2839 137.228 55.1344 139.266 55.2953C141.305 55.4562 143.101 53.8471 143.101 53.8471Z",
  fill: "#B7D972"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M143.369 49.7708C142.618 47.8668 140.392 46.955 140.392 46.955L143.101 53.874C143.101 53.8472 144.12 51.6749 143.369 49.7708Z",
  fill: "url(#paint8_linear_100_2)"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M143.101 53.8475L140.392 46.9285C140.392 46.9285 139.373 49.1007 140.124 51.0048C140.902 52.9357 143.101 53.8475 143.101 53.8475Z",
  fill: "#B7D972"
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M157.984 25.9301C157.528 24.6964 156.107 24.1064 156.107 24.1064L157.769 28.5582C157.769 28.5582 158.44 27.1637 157.984 25.9301Z",
  fill: "url(#paint9_linear_100_2)"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M157.77 28.5585L156.108 24.1067C156.108 24.1067 155.437 25.4744 155.893 26.708C156.349 27.9416 157.77 28.5585 157.77 28.5585Z",
  fill: "#B7D972"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M133.42 16.0347C131.516 15.3107 129.344 16.3297 129.344 16.3297L136.263 18.9579C136.29 18.9847 135.351 16.7856 133.42 16.0347Z",
  fill: "url(#paint10_linear_100_2)"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M136.29 18.9848L129.371 16.3567C129.371 16.3567 130.31 18.5558 132.214 19.3067C134.118 20.0039 136.29 18.9848 136.29 18.9848Z",
  fill: "#B7D972"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M146 116C146 116 150.607 111.043 154.342 112.466C158.052 113.866 158.675 111.332 160.617 112.177C162.56 113.021 165 115.133 165 115.133L146 116Z",
  fill: "#623B2A"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M154.847 84.5271C153.694 84.5271 152.38 84.2589 150.959 83.508C150.824 83.4276 150.771 83.2935 150.851 83.1594C150.932 83.0253 151.066 82.9717 151.2 83.0521C155.518 85.3317 158.602 82.918 158.736 82.8108C158.843 82.7303 159.004 82.7303 159.111 82.8644C159.192 82.9717 159.192 83.1326 159.084 83.2399C159.058 83.213 157.395 84.5271 154.847 84.5271Z",
  fill: "#E04E39"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M151.254 83.5619L150.798 83.2937C150.45 83.0792 147.366 81.2288 147.258 79.8074C147.231 79.4588 147.366 79.1638 147.661 78.9492C148.17 78.547 148.68 78.4129 149.135 78.6006C150.61 79.1906 151.12 82.6501 151.174 83.0524L151.254 83.5619ZM148.68 79.0297C148.465 79.0297 148.224 79.1369 147.982 79.3247C147.821 79.4588 147.768 79.5929 147.768 79.7538C147.821 80.5851 149.511 81.8456 150.557 82.5428C150.315 81.3628 149.779 79.432 148.921 79.0833C148.841 79.0565 148.76 79.0297 148.68 79.0297Z",
  fill: "#E04E39"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M147.955 86.7262C147.767 86.7262 147.499 86.6457 147.311 86.3239C147.15 86.0558 147.124 85.7608 147.231 85.4658C147.66 84.3394 150.1 83.4812 150.395 83.374L151.039 83.1594L150.717 83.7494C150.422 84.2589 149.001 86.7262 147.955 86.7262ZM149.859 84.1517C149.028 84.5003 147.928 85.0903 147.714 85.6535C147.66 85.7876 147.687 85.9217 147.74 86.0558C147.821 86.1898 147.901 86.1898 147.928 86.1898C148.411 86.2167 149.242 85.1439 149.859 84.1517Z",
  fill: "#E04E39"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5294 249L12.9393 250.515L14.6599 249.515L16.1416 251.364L17.7188 249.576L19.4633 251.576L21.0643 250.182L23 251.727L22.5221 252.667L21.0882 251.485L19.3916 253L17.7188 251.061L16.1177 252.879L14.4927 250.848L12.8199 251.818L11.5055 250.424L10.5019 251.333L10 250.455L11.5294 249Z",
  fill: "white"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M201.839 14.3866L195.387 13L193.687 17.2857L187.289 16.1261L184.94 20.0336L180.027 19.7311L180 21.5966L186.587 22L188.8 18.2941L195.468 19.5042L197.142 15.2689L203 16.5294L201.839 14.3866Z",
  fill: "white"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M391.094 133.032L393.446 129.161L391.504 125.078C391.286 124.601 391.696 124.097 392.215 124.23L396.727 125.211L400.117 122.162C400.5 121.817 401.129 122.056 401.184 122.56L401.621 127.04L405.668 129.214C406.133 129.453 406.105 130.116 405.613 130.328L401.375 132.104L400.473 136.505C400.363 137.008 399.707 137.168 399.379 136.796L396.317 133.429L391.723 133.96C391.176 134.013 390.821 133.456 391.094 133.032Z",
  fill: "white"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2392 27.9113C60.2392 27.9113 60.9633 25.8999 63.3501 25.1758C65.4955 24.5322 67.4801 25.7926 68.07 27.7772C68.7673 30.0835 67.5605 33.3821 63.0551 37.3243C57.1283 36.5466 54.3125 34.428 53.6152 32.1485C53.0252 30.164 53.9907 28.0185 56.1361 27.3749C58.5229 26.624 60.2392 27.9113 60.2392 27.9113Z",
  fill: "#CAA480"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8077 34.1325C44.98 33.8375 46.7231 33.5157 48.4127 33.0866C48.9758 32.9525 49.9681 32.872 50.2363 32.3089C50.3704 32.0139 50.3435 31.692 50.0485 31.5043C49.5122 31.1289 48.7345 31.5311 48.1713 31.6652C46.4549 32.0943 44.4973 32.4698 42.4859 32.7647C42.1105 32.8184 41.8691 33.2475 41.9496 33.5961C42.0568 33.9984 42.4323 34.1861 42.8077 34.1325Z",
  fill: "#CAA480"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M72.5219 31.5046C73.3533 31.3169 74.1578 31.1024 74.9892 30.9146C75.7669 30.7269 76.7323 30.6464 77.4028 30.1905C77.9123 29.8687 77.7782 29.1178 77.1346 29.0642C76.3301 28.9837 75.4451 29.3324 74.6674 29.5469C73.836 29.7614 73.0315 29.9492 72.2001 30.1637C71.3419 30.3783 71.637 31.7192 72.5219 31.5046Z",
  fill: "#CAA480"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M52.9985 43.0363C53.6153 41.0518 54.7416 40.2204 55.5194 39.3354C55.9484 38.8527 55.4657 38.1555 54.8757 38.4237C53.213 39.1209 52.1403 40.9982 51.6576 42.6341C51.3894 43.4922 52.7303 43.8945 52.9985 43.0363Z",
  fill: "#CAA480"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M63.5111 45.0748C63.2698 44.2434 63.1893 43.3852 63.3234 42.5003C63.4038 41.9639 64.0475 40.3816 63.0284 40.3548C62.063 40.328 61.9289 41.9371 61.8752 42.6343C61.7948 43.5462 61.8752 44.4848 62.1434 45.3698C62.3848 46.2279 63.7525 45.9329 63.5111 45.0748Z",
  fill: "#CAA480"
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M69.2233 38.2091C69.7597 38.4236 70.296 38.6382 70.8324 38.8795C71.3687 39.0941 71.9319 39.4695 72.4951 39.2013C72.8169 39.0404 72.8706 38.6918 72.7633 38.3968C72.5488 37.8604 71.7442 37.6996 71.2615 37.5118C70.7251 37.2973 70.1888 37.0827 69.6524 36.8682C69.3038 36.7341 68.8747 37.0023 68.7674 37.3509C68.6333 37.7264 68.8479 38.075 69.2233 38.2091Z",
  fill: "#CAA480"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M53.3741 24.2372C50.6119 20.4559 50.6387 20.4291 50.2096 20.1877C49.7537 19.9195 49.1637 20.3218 49.2978 20.8313C49.4319 21.3408 49.4051 21.2604 52.3282 25.2294C52.5696 25.5513 53.0791 25.5244 53.3473 25.2563C53.6423 24.9613 53.5887 24.559 53.3741 24.2372Z",
  fill: "#CAA480"
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M60.8561 22.3867C60.9634 21.6358 60.9902 20.8581 60.9097 20.0804C60.8561 19.3563 60.8561 18.2567 60.1052 17.9349C59.9443 17.8545 59.6761 17.9349 59.5688 18.069C59.0861 18.6054 59.4348 19.5172 59.4884 20.1608C59.542 20.8849 59.5152 21.609 59.4347 22.3062C59.4079 22.6817 59.7566 23.0303 60.1052 23.0303C60.5343 23.084 60.8025 22.7621 60.8561 22.3867Z",
  fill: "#CAA480"
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M71.5831 20.5098C71.6368 20.1612 71.2881 19.9198 70.9931 19.8662C70.3763 19.7857 69.7595 20.5098 69.3572 20.9121C68.8745 21.368 68.4454 21.8775 68.07 22.4139C67.8555 22.7089 67.9895 23.1916 68.3113 23.3793C68.66 23.5938 69.0354 23.4598 69.2768 23.138C70.8322 21.2071 71.4759 21.368 71.5831 20.5098Z",
  fill: "#CAA480"
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0321 283.751C16.6447 286.781 19.8334 289.194 22.6644 288.988C25.7934 288.782 28.4755 286.222 28.9225 283.192C29.4291 279.898 27.4027 277.25 24.3034 277.015C21.2936 276.779 19.3566 279.427 20.2208 282.104C20.8466 284.016 22.6346 284.752 23.5286 284.222C24.214 283.81 24.1842 282.781 23.3498 282.575C23.022 282.516 22.6644 282.692 22.4856 282.957C21.7406 282.663 21.0552 281.339 21.532 279.898C22.128 278.074 24.4822 277.956 25.9424 278.809C27.7901 279.898 28.0881 282.251 27.4027 284.104C26.6875 286.075 24.7504 287.605 22.6048 287.752C20.191 287.929 18.0752 286.105 17.8963 283.722C17.8367 283.192 17.0917 283.192 17.0321 283.751Z",
  fill: "#E04E39"
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6398 190.258L27.5863 184.824L23.3074 181.784C22.826 181.446 22.933 180.658 23.4679 180.461L28.3619 178.744L29.7793 173.536C29.9397 172.944 30.6886 172.804 31.0362 173.31L34.1117 177.674L39.2731 177.505C39.8615 177.477 40.2091 178.181 39.8615 178.687L36.8662 183.107L38.6313 188.203C38.8185 188.794 38.3104 189.357 37.7488 189.16L32.828 187.527L28.763 190.849C28.3084 191.215 27.6398 190.877 27.6398 190.258Z",
  fill: "#977F75"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M387.144 214.488C386.983 212.101 388.779 210.036 391.139 209.875C393.526 209.714 395.591 211.511 395.752 213.898C395.913 216.284 394.116 218.349 391.756 218.51C389.369 218.671 387.304 216.874 387.144 214.488Z",
  fill: "#E04E39"
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M394.465 226.689C394.197 225.429 394.063 224.088 393.634 222.881C393.258 221.835 391.649 222.157 391.73 223.284C391.837 224.651 392.266 226.046 392.534 227.36C392.641 227.896 393.365 228.164 393.848 227.977C394.411 227.789 394.572 227.226 394.465 226.689Z",
  fill: "#E04E39"
});

var _ref116 = /*#__PURE__*/React.createElement("path", {
  d: "M401.867 221.353C400.445 220.522 399.185 219.476 397.871 218.457C396.852 217.679 395.725 219.02 396.583 219.932C397.79 221.273 399.399 222.292 400.955 223.204C401.437 223.499 402.135 223.204 402.349 222.721C402.617 222.211 402.349 221.621 401.867 221.353Z",
  fill: "#E04E39"
});

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M399.158 213.602C398.837 213.87 398.783 214.246 398.971 214.594C399.453 215.479 400.687 215.426 401.545 215.399C402.457 215.372 403.369 215.184 404.227 214.889C405.487 214.46 404.817 212.476 403.53 212.905C401.036 213.79 400.097 212.851 399.158 213.602Z",
  fill: "#E04E39"
});

var _ref118 = /*#__PURE__*/React.createElement("path", {
  d: "M397.791 205.208C396.53 207.059 395.511 207.676 395.672 208.668C395.753 209.258 396.235 209.553 396.799 209.419C397.469 209.258 397.845 208.56 398.247 208.051C398.622 207.568 399.025 207.085 399.373 206.576C399.695 206.12 399.722 205.503 399.266 205.101C398.864 204.779 398.113 204.752 397.791 205.208Z",
  fill: "#E04E39"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M392.883 204.887C392.481 203.76 392.4 203.358 391.864 202.848C391.408 202.393 390.443 202.688 390.389 203.358C390.308 204.136 390.469 204.431 390.898 205.584C391.086 206.12 391.703 206.415 392.239 206.228C392.776 206.04 393.071 205.423 392.883 204.887Z",
  fill: "#E04E39"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M387.6 207.596C385.776 206.228 385.427 205.826 384.703 205.906C384.274 205.96 383.818 206.362 383.899 206.818C384.06 207.676 384.569 207.918 386.232 209.151C386.688 209.473 387.305 209.5 387.68 209.044C388.056 208.642 388.056 207.944 387.6 207.596Z",
  fill: "#E04E39"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M380.332 213.897C379.608 214.273 379.903 215.506 380.681 215.614C381.432 215.721 381.7 215.587 385.293 214.943C385.857 214.836 386.312 214.434 386.259 213.817C386.232 213.307 385.696 212.744 385.132 212.851C381.405 213.522 381.029 213.522 380.332 213.897Z",
  fill: "#E04E39"
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M385.964 219.797C383.979 221.701 383.711 221.379 382.933 222.532C382.585 223.069 383.175 223.927 383.791 223.793C384.596 223.659 384.811 223.525 385.83 222.693C386.42 222.211 387.01 221.701 387.573 221.165C387.975 220.762 387.868 220.038 387.466 219.69C386.983 219.287 386.366 219.395 385.964 219.797Z",
  fill: "#E04E39"
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M55.0316 404H60V180.115C60 178.964 58.8924 178 57.5 178C56.1392 178 55 178.937 55 180.115V404H55.0316Z",
  fill: "#C39367"
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M83.0253 404H87V175.126C87 173.969 86.1139 173 85 173C83.9114 173 83 173.942 83 175.126V404H83.0253Z",
  fill: "#C39367"
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M87 201H58V204H87V201Z",
  fill: "#C39367"
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M87 235H58V239H87V235Z",
  fill: "#C39367"
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M87 269H58V272H87V269Z",
  fill: "#C39367"
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M87 304H58V306H87V304Z",
  fill: "#C39367"
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M66.0536 324.736H47.7101C46.2083 324.736 44.9747 325.97 44.9747 327.471V337.769H48.032V328.008H66.0536V324.736Z",
  fill: "#13375B"
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M69.5667 317.79L63.8813 311.783C63.8813 311.783 57.7937 315.135 50.7137 318.326C48.756 314.921 45.5915 303.764 45.4038 303.228C45.2429 302.692 49.1315 295.987 48.2465 295.826C47.3615 295.665 46.2352 299.42 45.3233 299.018C44.4115 298.642 42.0247 289.926 41.4884 290.409C40.4425 291.294 42.722 295.826 42.1856 296.148C41.6493 296.47 40.2548 291.133 39.182 291.374C38.1361 291.589 40.9788 296.228 40.657 296.684C40.3352 297.14 37.3852 292.769 36.7684 293.788C36.4466 294.324 39.5039 297.569 38.8871 297.945C38.2434 298.32 35.4812 296.255 35.1594 296.926C34.8375 297.596 37.7339 298.267 38.5652 299.956C39.3698 301.619 40.8448 302.289 41.3275 305.454C41.8102 308.618 43.1511 325.514 46.5838 326.881C49.5874 328.034 69.5667 317.79 69.5667 317.79Z",
  fill: "#F7A491"
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M121.995 395.722C122.451 392.53 122.398 386.657 122.183 380.436C124.972 380.301 127.305 380.114 130.094 379.926C128.941 387.864 128.163 396.017 128.163 396.017L128.351 397.572L128.458 402.212L112.716 402.319C112.716 402.319 116.042 400.844 120.681 397.948C121.03 397.787 121.808 397.089 121.995 395.722Z",
  fill: "#F7A491"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M128.888 403.257L112.287 403.445C111.697 403.391 111.537 402.909 111.751 402.614C112.18 401.997 114.084 401.541 116.203 400.549C119.931 400.951 127.761 398.377 128.351 397.518C128.7 399.262 129.21 403.177 128.888 403.257Z",
  fill: "#2C2A29"
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M150.208 392.45C148.921 389.5 145.783 384.512 142.297 379.363C144.577 377.781 146.856 376.172 149.109 374.536C152.3 381.884 155.599 389.474 155.599 389.474L156.591 390.707L159.139 394.596L145.81 402.99C145.81 402.99 147.848 399.986 150.262 395.079C150.45 394.703 150.771 393.711 150.208 392.45Z",
  fill: "#F7A491"
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M159.836 395.562L146.025 404.117C145.489 404.385 145.113 404.063 145.113 403.687C145.14 402.937 146.535 401.542 147.822 399.584C151.201 397.948 156.484 391.619 156.511 390.573C157.718 391.861 160.078 395.32 159.836 395.562Z",
  fill: "#2C2A29"
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M143.745 262.786C144.978 256.779 141.117 250.825 135.699 248.599C135.726 245.193 134.627 240.849 132.294 238.516C127.681 233.903 118.911 232.294 115.532 238.167C111.054 240.688 107.541 246.159 108.882 251.147C104.537 255.626 106.2 263.751 112.502 267.586C112.395 272.628 115.05 277.616 119.475 279.762C120.521 280.271 122.183 280.995 122.398 281.21C122.13 280.942 125.67 290.784 136.638 286.278C147.821 281.719 151.039 268.766 143.745 262.786Z",
  fill: "#002A24"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M121.701 391.217C123.068 383.655 118.322 364.909 115.452 356.676C112.449 348.094 110.544 311.81 110.544 311.81L113.95 307.841L127.842 307.009C127.842 307.009 121.915 325.192 121.915 331.413C121.915 337.635 124.785 353.78 128.164 362.174C131.275 369.924 129.987 386.122 129.049 391.459C126.555 391.861 124.168 391.727 121.701 391.217Z",
  fill: "#C39367"
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M131.355 308.671C131.999 309.315 135.726 313.739 135.726 316.824C135.726 319.908 128.673 347.745 130.363 349.434C132.052 351.124 138.301 355.334 142.297 361.234C145.649 366.195 153.373 380.516 154.848 383.922C151.951 385.933 149.43 386.872 146.507 387.837C146.051 385.29 123.283 360.215 120.682 354.959C118.08 349.702 116.686 325.727 115.372 322.536C114.058 319.344 110.544 311.245 110.544 311.245L131.355 308.671Z",
  fill: "#CAA480"
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M111.081 288.182C111.081 288.182 102.499 297.971 93.0053 301.671C91.5303 302.235 90.243 303.361 90.243 303.361C90.243 304.353 92.013 303.629 92.013 303.629C92.013 303.629 91.423 304.595 91.718 305.801C92.0398 306.981 94.1048 306.204 95.2312 306.204C95.7407 306.204 98.3957 303.254 101.962 301.511C106.2 299.446 111.188 297.434 111.805 296.817C112.958 295.664 111.402 287.807 111.081 288.182Z",
  fill: "#F79C8D"
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M128.539 260.614C128.539 260.614 119.904 259.729 115.399 262.625C110.893 265.495 108.024 275.739 108.024 280.111C108.024 284.482 111.269 307.465 110.035 311.836C110.035 311.836 124.302 311.219 129.183 311.219C134.064 311.219 135.056 309.342 135.056 309.342C135.056 309.342 124.919 299.339 124.919 294.968C124.892 290.596 128.539 260.614 128.539 260.614Z",
  fill: "#E04E39"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5942 378.399V393.39H12.2033V379.766H22.9305V384.433C18.7737 384.888 15.5287 388.723 15.5287 393.363C15.5287 398.324 19.2028 402.347 23.735 402.347C28.2672 402.347 31.9413 398.324 31.9413 393.363C31.9413 388.697 28.6963 384.862 24.5395 384.433V379.766H26.7654V377.996H24.5395V372.606H26.7654V370.836H24.5395V364.829H53.9051V362.174H37.7339V346.914C37.7339 342.838 41.4884 338.279 46.5034 338.279H60.4487V335.624H46.5034C40.5498 335.624 35.3203 340.907 35.3203 346.914V362.174H24.5932V353.619H22.9841V370.836H17.54C13.7051 370.836 10.5942 374.215 10.5942 378.399ZM22.9573 377.996H12.2301C12.4178 374.993 14.7242 372.606 17.5132 372.606H22.9573V377.996Z",
  fill: "#2C2A29"
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9501 380.758C16.9501 380.758 17.2719 386.524 17.2719 386.551C17.3792 387.275 17.862 389.098 17.862 389.769C17.862 392.263 6.70569 387.65 9.22657 386.524C9.44112 386.417 10.7284 385.049 11.0502 384.244C11.6134 382.823 11.8816 380.061 11.8816 380.061L16.9501 380.758Z",
  fill: "#F48C7F"
});

var _ref142 = /*#__PURE__*/React.createElement("path", {
  d: "M9.25317 386.498C9.25317 386.498 11.8813 387.275 13.2222 387.463C14.5631 387.651 16.3331 386.042 17.2717 386.471C18.3176 386.954 18.3713 391.352 18.3713 391.352C18.3713 391.352 4.37231 391.808 0.295994 391.218C-1.31308 390.976 3.91642 388.294 9.25317 386.498Z",
  fill: "#2C2A29"
});

var _ref143 = /*#__PURE__*/React.createElement("path", {
  d: "M72.7578 368.422H75.8419V309.771C75.8419 307.786 77.7728 306.177 80.1595 306.177H107.862C108.613 306.177 109.203 305.614 109.203 304.89C109.203 304.193 108.613 303.603 107.862 303.603H80.1595C76.0832 303.603 72.7578 306.365 72.7578 309.744V368.422Z",
  fill: "#2C2A29"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M58.3038 393.603C68.5679 393.603 76.8886 385.211 76.8886 374.858C76.8886 364.505 68.5679 356.112 58.3038 356.112C48.0397 356.112 39.719 364.505 39.719 374.858C39.719 385.211 48.0397 393.603 58.3038 393.603Z",
  fill: "#E04E39"
});

var _ref145 = /*#__PURE__*/React.createElement("path", {
  d: "M35.6959 374.858C35.6959 387.462 45.8331 397.68 58.3034 397.68C70.8005 397.68 80.9109 387.462 80.9109 374.858C80.9109 362.253 70.7737 352.036 58.3034 352.036C45.8331 352.036 35.6959 362.253 35.6959 374.858ZM37.8414 374.858C37.8414 363.46 47.0131 354.208 58.3302 354.208C69.6474 354.208 78.8191 363.46 78.8191 374.858C78.8191 386.255 69.6474 395.508 58.3302 395.508C47.0131 395.508 37.8414 386.255 37.8414 374.858Z",
  fill: "#2C2A29"
});

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M73.1603 348.845H82.2515V313.634H73.1603V348.845Z",
  fill: "#2C2A29"
});

var _ref147 = /*#__PURE__*/React.createElement("path", {
  d: "M43.3388 370.835H35.6421C31.4853 370.835 28.1331 374.241 28.1331 378.425V393.416H29.9031V378.425C29.9031 375.233 32.4776 372.605 35.6689 372.605H43.3656V370.835H43.3388Z",
  fill: "#2C2A29"
});

var _ref148 = /*#__PURE__*/React.createElement("path", {
  d: "M40.1743 351.125H16.2795V355.228H40.1743V351.125Z",
  fill: "#2C2A29"
});

var _ref149 = /*#__PURE__*/React.createElement("path", {
  d: "M43.2047 377.996H29.0181V379.766H43.2047V377.996Z",
  fill: "#2C2A29"
});

var _ref150 = /*#__PURE__*/React.createElement("path", {
  d: "M75.2253 362.146H42.4539V364.801H75.2253V362.146Z",
  fill: "#2C2A29"
});

var _ref151 = /*#__PURE__*/React.createElement("path", {
  d: "M82.2515 351.07H39.5842V355.227H82.2515V351.07Z",
  fill: "#2C2A29"
});

var _ref152 = /*#__PURE__*/React.createElement("path", {
  d: "M80.9374 371.56H83.5655V312.91C83.5655 310.925 85.2282 309.316 87.2664 309.316H112.153V306.768H87.2664C83.7801 306.768 80.9374 309.53 80.9374 312.91V371.56Z",
  fill: "#2C2A29"
});

var _ref153 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5309 393.39C32.5309 398.351 36.9558 402.374 42.4267 402.374C47.8975 402.374 52.3225 398.351 52.3225 393.39C52.3225 388.429 47.8975 384.406 42.4267 384.406C36.9827 384.406 32.5309 388.429 32.5309 393.39Z",
  fill: "#E28B7E"
});

var _ref154 = /*#__PURE__*/React.createElement("path", {
  d: "M36.4197 393.39C36.4197 396.42 39.1283 398.861 42.4537 398.861C45.7791 398.861 48.4877 396.42 48.4877 393.39C48.4877 390.359 45.7791 387.919 42.4537 387.919C39.1015 387.919 36.4197 390.359 36.4197 393.39Z",
  fill: "#2C2A29"
});

var _ref155 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2908 335.623C21.1603 332.754 61.0653 334.148 61.0653 334.148C61.0653 334.148 27.248 342.408 25.2635 343.481C23.279 344.554 15.9308 380.865 15.9308 381.348C13.8927 380.865 12.6591 381.24 10.5673 380.811C10.9427 374.482 13.6781 340.236 18.2908 335.623Z",
  fill: "#C39367"
});

var _ref156 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1794 380.946C22.1794 380.946 22.5012 386.712 22.5012 386.739C22.6085 387.463 23.0912 389.286 23.0912 389.957C23.0912 392.451 11.9349 387.838 14.4558 386.712C14.6704 386.605 16.2258 385.29 16.2795 384.432C16.3867 383.118 16.3331 381.026 16.3331 381.026L22.1794 380.946Z",
  fill: "#F7A491"
});

var _ref157 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4826 386.685C14.4826 386.685 17.1107 387.463 18.4516 387.651C19.7925 387.839 21.5625 386.23 22.5011 386.659C23.547 387.141 23.6007 391.54 23.6007 391.54C23.6007 391.54 9.60174 391.995 5.52542 391.405C3.88953 391.164 9.14584 388.455 14.4826 386.685Z",
  fill: "#2C2A29"
});

var _ref158 = /*#__PURE__*/React.createElement("path", {
  d: "M67.2868 342.328C67.2868 342.328 66.9382 351.393 63.9346 351.5C60.931 351.607 41.5685 352.036 30.6536 351.071L23.3323 383.494L14.7238 382.662C14.7238 382.662 17.3251 361.02 18.2369 352.787C19.1487 344.688 21.7501 337.903 26.3359 337.716C30.9218 337.555 61.0115 332.888 61.0115 332.888L67.2868 342.328Z",
  fill: "#CAA480"
});

var _ref159 = /*#__PURE__*/React.createElement("path", {
  d: "M75.4129 300.037C75.4129 300.037 80.2937 301.271 79.6233 310.818C78.9528 320.365 73.6697 349.248 63.9348 351.5C54.1731 353.78 47.8173 333.211 47.8173 333.211C47.8173 333.211 53.9854 331.199 56.5331 321.625C58.3031 315.001 63.0767 300.064 64.2566 299.34C67.2334 297.57 75.4129 300.037 75.4129 300.037Z",
  fill: "#767575"
});

var _ref160 = /*#__PURE__*/React.createElement("path", {
  d: "M54.951 364.212H57.5792V346.914C57.5792 342.838 61.6555 338.279 67.0727 338.279H82.2248V335.624H67.0727C60.6096 335.624 54.9242 340.907 54.9242 346.914V364.212H54.951Z",
  fill: "#2C2A29"
});

var _ref161 = /*#__PURE__*/React.createElement("path", {
  d: "M82.2518 398.861C94.0415 398.861 103.599 389.219 103.599 377.326C103.599 365.432 94.0415 355.791 82.2518 355.791C70.4622 355.791 60.9048 365.432 60.9048 377.326C60.9048 389.219 70.4622 398.861 82.2518 398.861Z",
  fill: "#2C2A29"
});

var _ref162 = /*#__PURE__*/React.createElement("path", {
  d: "M56.2651 377.326C56.2651 391.808 67.9041 403.527 82.2517 403.527C96.5992 403.527 108.238 391.781 108.238 377.326C108.238 362.844 96.5992 351.125 82.2517 351.125C67.9041 351.125 56.2651 362.844 56.2651 377.326ZM58.7324 377.326C58.7324 364.212 69.2718 353.592 82.2517 353.592C95.2315 353.592 105.771 364.212 105.771 377.326C105.771 390.44 95.2315 401.06 82.2517 401.06C69.2718 401.06 58.7324 390.44 58.7324 377.326Z",
  fill: "#2C2A29"
});

var _ref163 = /*#__PURE__*/React.createElement("path", {
  d: "M82.2515 395.079C91.9676 395.079 99.844 387.13 99.844 377.325C99.844 367.52 91.9676 359.572 82.2515 359.572C72.5354 359.572 64.6589 367.52 64.6589 377.325C64.6589 387.13 72.5354 395.079 82.2515 395.079Z",
  fill: "#E04E39"
});

var _ref164 = /*#__PURE__*/React.createElement("path", {
  d: "M78.2823 377.326C78.2823 379.525 80.0523 381.322 82.2514 381.322C84.4505 381.322 86.2205 379.525 86.2205 377.326C86.2205 375.127 84.4505 373.33 82.2514 373.33C80.0523 373.33 78.2823 375.127 78.2823 377.326Z",
  fill: "#2C2A29"
});

var _ref165 = /*#__PURE__*/React.createElement("path", {
  d: "M3.7635 396.117H30.635V391.478H3.7635V396.117Z",
  fill: "#623B2A"
});

var _ref166 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3766 396.117H30.636V391.478H15.3766V396.117Z",
  fill: "#623B2A"
});

var _ref167 = /*#__PURE__*/React.createElement("path", {
  d: "M43.3389 355.174H41.569V396.125H43.3389V355.174Z",
  fill: "#2C2A29"
});

var _ref168 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4077 393.899C41.4077 394.516 41.8904 394.998 42.4804 394.998C43.0704 394.998 43.5531 394.516 43.5531 393.899C43.5531 393.282 43.0704 392.799 42.4804 392.799C41.8904 392.799 41.4077 393.309 41.4077 393.899Z",
  fill: "#DE7964"
});

var _ref169 = /*#__PURE__*/React.createElement("path", {
  d: "M72.4631 274.479C72.4631 274.479 75.8957 272.173 77.3439 276.222C77.3439 276.195 78.5507 276.195 78.7116 276.249C79.4089 276.49 80.1062 277.214 80.723 277.617C82.9489 279.038 83.9947 281.827 84.102 284.375C84.2629 287.486 82.9757 289.738 80.9375 291.964C80.3475 292.635 79.7039 293.278 78.8993 293.681C77.9607 294.19 77.2098 293.788 76.298 294.002C75.5471 294.19 75.2789 294.968 74.3939 294.7C73.1603 294.297 71.8462 292.742 70.3176 292.983C68.789 293.225 65.2222 291.83 65.2222 291.83C60.6632 290.06 63.7472 281.237 64.6054 278.099C65.4636 275.176 69.6472 273.406 72.4631 274.479Z",
  fill: "#002A24"
});

var _ref170 = /*#__PURE__*/React.createElement("path", {
  d: "M68.3336 294.539L67.1536 297.757L66.51 299.554C66.51 299.554 66.4564 302.798 67.2073 303.63C68.4945 305.078 73.8313 299.741 73.8313 299.741L75.5208 289.577L68.3336 294.539Z",
  fill: "#F7A491"
});

var _ref171 = /*#__PURE__*/React.createElement("path", {
  d: "M75.0111 292.876C72.9729 296.014 69.4866 297.462 67.1534 297.81L68.3602 294.539L75.5743 289.577L75.0111 292.876Z",
  fill: "#F47458"
});

var _ref172 = /*#__PURE__*/React.createElement("path", {
  d: "M74.153 279.119C71.4444 277.456 67.8776 278.716 66.7512 281.639C66.2685 282.927 65.7322 284.536 65.3031 286.333C64.2572 290.677 65.5712 295.397 67.5558 295.853C69.5403 296.282 75.628 294.673 77.1834 288.532C78.1488 284.75 77.0225 280.862 74.153 279.119Z",
  fill: "#F7A491"
});

var _ref173 = /*#__PURE__*/React.createElement("path", {
  d: "M75.6281 288.72C75.4135 289.685 75.8694 290.597 76.674 290.785C77.4517 290.946 78.2562 290.329 78.4708 289.363C78.6853 288.398 78.2294 287.486 77.4249 287.298C76.6203 287.111 75.8426 287.754 75.6281 288.72Z",
  fill: "#F7A491"
});

var _ref174 = /*#__PURE__*/React.createElement("path", {
  d: "M69.5136 290.516C69.5136 290.516 72.1149 291.374 72.3295 292.313C72.544 293.278 72.2222 294.646 70.9349 295.719C69.6477 296.792 66.939 296.121 66.1881 295.531C65.4372 294.941 64.8741 292.474 65.625 291.079C66.3759 289.712 69.5136 290.516 69.5136 290.516Z",
  fill: "#002A24"
});

var _ref175 = /*#__PURE__*/React.createElement("path", {
  d: "M70.3715 292.527C70.3715 292.527 70.3447 293.6 69.9961 293.788C69.6474 293.976 69.2183 294.136 68.8161 294.163C68.1724 294.217 67.5556 293.949 67.2338 293.439C67.207 293.386 67.1802 293.332 67.1533 293.278C66.8852 292.742 66.8315 291.803 66.8315 291.803C66.8315 291.803 67.9311 291.535 68.5747 291.642C69.1915 291.75 70.3715 292.527 70.3715 292.527Z",
  fill: "#F7A491"
});

var _ref176 = /*#__PURE__*/React.createElement("path", {
  d: "M98.5568 304.97C99.6027 303.951 104.376 302.342 107.997 299.714C109.606 298.561 112.69 297.032 115.693 295.369C117.892 296.576 119.877 298.105 121.352 299.928C115.908 302.422 110.008 304.943 109.123 305.828C107.434 307.518 104.484 311.326 103.813 311.326C103.116 311.326 97.8864 309.797 97.1086 309.02C96.3309 308.242 97.5109 305.989 98.5568 304.97Z",
  fill: "#F79C8D"
});

var _ref177 = /*#__PURE__*/React.createElement("path", {
  d: "M115.694 295.37C119.475 293.278 123.149 290.972 123.525 288.907C124.222 285.233 121.084 269.303 122.827 266.219C124.57 263.161 128.513 260.587 128.513 260.587C129.129 260.587 131.382 261.955 132.026 264.717C132.643 267.452 131.516 292.205 130.899 294.458C130.604 295.504 126.314 299.714 121.513 301.94C120.038 300.116 117.893 296.577 115.694 295.37Z",
  fill: "#E04E39"
});

var _ref178 = /*#__PURE__*/React.createElement("path", {
  d: "M76.6732 328.731L61.5747 332.7C61.5747 332.7 57.1229 335.892 55.1384 336.535C53.1539 337.179 50.7134 339.378 51.1693 340.049C51.6521 340.719 54.1462 338.439 54.5752 338.493C54.9775 338.574 53.1002 341.282 52.8052 343.052C52.5102 344.822 51.8934 346.565 52.9125 346.431C53.9316 346.297 54.6825 342.274 54.6825 342.274C54.6825 342.274 56.2379 339.244 56.5061 339.593C56.7475 339.941 55.4602 342.033 55.4602 342.033C55.4602 342.033 55.1384 344.286 55.0043 345.064C54.897 345.653 55.4334 347.423 55.9161 346.78C56.1843 346.404 56.0502 344.929 56.372 344.098C57.0157 342.382 58.0884 341.041 58.0884 341.041C58.0884 341.041 56.962 346.163 57.6593 346.297C58.3834 346.431 59.1074 342.167 59.1074 342.167C59.1074 342.167 60.8506 338.627 61.6015 338.305C62.3524 337.984 64.4442 336.643 66.0801 336.08C67.6892 335.516 74.3937 337.367 77.3704 337.394C80.3472 337.42 85.2013 335.597 85.6035 333.237C85.7376 332.513 85.2817 331.735 84.6113 330.984C82.5999 328.839 79.5427 327.981 76.6732 328.731Z",
  fill: "#F7A491"
});

var _ref179 = /*#__PURE__*/React.createElement("path", {
  d: "M75.4127 300.036C75.4127 300.036 79.9718 299.231 84.1285 306.66C88.2585 314.089 85.5767 333.263 85.5767 333.263L76.6731 328.731L75.4127 300.036Z",
  fill: "#51504F"
});

var _ref180 = /*#__PURE__*/React.createElement("path", {
  d: "M95.7676 306.446C95.2312 306.446 92.4154 306.633 91.9863 306.177C91.5572 305.748 93.4344 304.595 93.6222 304.81C93.8099 304.997 94.6144 304.568 94.8826 304.837C95.1508 305.105 95.9553 304.81 96.1967 305.024C96.4112 305.266 96.304 306.446 95.7676 306.446Z",
  fill: "#F48C7F"
});

var _ref181 = /*#__PURE__*/React.createElement("path", {
  d: "M124.06 252.89C124.06 252.89 123.095 258.173 123.283 260.265C123.47 262.357 122.559 269.061 118.402 269.088C114.245 269.115 117.061 262.115 117.463 260.077C117.865 258.039 118.482 250.128 118.482 250.128L124.06 252.89Z",
  fill: "#F7A491"
});

var _ref182 = /*#__PURE__*/React.createElement("path", {
  d: "M118.214 253.132C118.268 251.388 118.59 250.021 118.59 250.021L124.034 252.89C124.034 252.89 123.846 253.963 123.632 255.358C121.218 255.867 119.287 254.741 118.214 253.132Z",
  fill: "#F47458"
});

var _ref183 = /*#__PURE__*/React.createElement("path", {
  d: "M124.168 237.55C124.168 237.55 126.501 238.382 127.788 240.929C129.048 243.477 129.478 250.611 124.355 253.346C119.233 256.081 115.827 251.04 116.149 246.507C116.444 241.975 117.892 236.048 124.168 237.55Z",
  fill: "#F7A491"
});

var _ref184 = /*#__PURE__*/React.createElement("path", {
  d: "M114.621 245.22C114.487 246.4 114.889 247.392 115.559 247.446C116.203 247.499 116.847 246.614 116.981 245.434C117.115 244.254 116.712 243.262 116.042 243.208C115.372 243.155 114.755 244.066 114.621 245.22Z",
  fill: "#F7A491"
});

var _ref185 = /*#__PURE__*/React.createElement("path", {
  d: "M127.333 247.204C126.877 248.331 127.118 249.538 127.842 249.859C128.566 250.181 129.532 249.538 129.988 248.411C130.444 247.285 130.202 246.078 129.478 245.756C128.727 245.408 127.789 246.078 127.333 247.204Z",
  fill: "#F7A491"
});

var _ref186 = /*#__PURE__*/React.createElement("path", {
  d: "M360.138 60.1772L370.168 73.9348L376.792 66.6672L360.138 60.1772Z",
  fill: "#DE7964"
});

var _ref187 = /*#__PURE__*/React.createElement("path", {
  d: "M377.704 62.859L376.792 66.6672L360.138 60.1772L377.704 62.859Z",
  fill: "#E04E39"
});

var _ref188 = /*#__PURE__*/React.createElement("path", {
  d: "M376.792 68.1153L360.138 60.1772L375.612 73.9348L376.792 68.1153Z",
  fill: "#E04E39"
});

var _ref189 = /*#__PURE__*/React.createElement("path", {
  d: "M386.902 84.6073C386.768 84.6073 383.845 84.2855 380.144 81.9791C376.417 79.6728 375.022 75.6233 375.022 74.9529C375.022 74.7115 375.237 74.4969 375.478 74.4969C375.719 74.4969 375.934 74.6847 375.934 74.926C375.988 75.3551 377.168 79.0292 380.627 81.1746C384.14 83.3737 386.983 83.6687 387.01 83.6687C387.251 83.6955 387.439 83.91 387.412 84.1514C387.385 84.4464 387.171 84.6073 386.902 84.6073Z",
  fill: "white"
});

var _ref190 = /*#__PURE__*/React.createElement("path", {
  d: "M405.112 88.6575C399.909 87.6116 394.948 85.7075 390.362 82.9721C386.581 80.7194 383.523 77.2867 379.635 75.3558C379.42 75.2485 379.313 74.9803 379.42 74.7658C379.528 74.5512 379.796 74.444 380.01 74.5512C384.006 76.5358 387.037 79.9685 390.791 82.1943C395.297 84.8761 400.177 86.7534 405.273 87.7725C407.15 88.1479 409.349 88.282 411.87 88.1747C412.111 88.1747 412.326 88.3625 412.326 88.6038C412.326 88.8452 412.138 89.0597 411.897 89.0597C409.698 89.1938 407.311 89.1134 405.112 88.6575Z",
  fill: "white"
});

var _ref191 = /*#__PURE__*/React.createElement("path", {
  d: "M215.351 224.117C215.351 224.117 204.329 204.433 201.647 200.276C198.965 196.092 191.993 179.465 191.724 178.822C191.483 178.178 196.525 170.294 195.399 170.025C194.272 169.757 193.012 174.182 191.805 173.646C190.598 173.11 187.085 162.49 186.388 163.026C185.1 164.018 188.292 169.623 187.595 169.972C186.897 170.32 184.832 163.804 183.491 163.991C182.151 164.179 186.039 169.972 185.664 170.481C185.288 170.991 181.239 165.547 180.515 166.7C180.112 167.344 184.242 171.447 183.438 171.849C182.633 172.225 178.986 169.57 178.584 170.347C178.208 171.125 181.99 172.171 183.116 174.236C184.242 176.301 186.173 177.213 186.978 181.048C187.782 184.883 188.962 198.774 193.065 205.693C197.169 212.612 206.179 227.952 206.179 227.952L215.351 224.117Z",
  fill: "#F79C8D"
});

var _ref192 = /*#__PURE__*/React.createElement("path", {
  d: "M264.213 319.052C264.213 319.052 263.328 317.926 263.06 317.55C262.738 317.094 261.907 315.619 261.907 315.619C261.907 315.619 259.225 310.39 259.627 310.229C260.03 310.068 260.995 310.712 261.263 310.953C261.532 311.221 261.88 311.489 262.175 311.758C262.443 312.026 262.872 312.026 263.221 311.704C263.57 311.382 262.685 310.095 262.309 309.693C261.076 308.486 257.16 305.938 256.731 305.643C256.248 305.294 253.272 295.372 251.984 292.073C250.027 286.576 248.283 280.837 248.096 280.247L246.862 255.306L237.556 252.195C237.556 252.195 238.522 279.898 238.736 281.266C238.844 281.909 244.341 294.299 244.368 294.299C247.479 300.226 250.214 305.429 250.724 306.448C250.724 306.448 251.394 309.88 251.689 312.106C251.984 314.332 253.164 316.236 253.352 316.853C253.379 316.933 253.888 319.079 255.417 321.278C256.731 323.182 256.356 320.742 256.356 320.742C256.356 320.742 254.532 316.773 254.881 316.665C255.149 316.585 256.007 318.838 257.455 320.956C257.831 321.492 258.206 322.029 258.528 322.538C259.44 323.826 260.486 323.638 259.761 322.136C259.493 321.6 259.064 320.742 258.662 320.152C258.233 319.535 258.018 318.811 257.723 318.247C257.16 317.094 256.704 316.263 256.785 316.263C256.865 316.263 256.919 315.941 257.321 316.531C257.804 317.202 258.555 318.891 259.359 319.857C259.815 320.393 260.7 321.573 260.7 321.573C260.7 321.573 262.336 323.316 262.47 323.262C263.141 322.887 262.309 321.278 261.585 320.634C261.344 319.991 260.378 318.784 260.378 318.784C260.378 318.784 258.984 315.888 259.386 315.673C259.708 315.485 264.428 321.787 265.071 321.358C265.527 321.01 264.213 319.052 264.213 319.052Z",
  fill: "#F48C7F"
});

var _ref193 = /*#__PURE__*/React.createElement("path", {
  d: "M247.533 221.864C247.747 216.42 246.969 211.057 244.529 205.988C242.437 201.617 237.261 199.15 232.515 199.15C217.497 199.123 215.592 218.968 206.045 226.611C203.122 228.944 199.877 230.848 197.115 233.369C186.924 242.675 191.51 259.892 200.869 268.072C207.359 273.73 217.577 276.948 225.596 272.523C229.779 270.217 232.944 266.382 235.223 262.172C238.441 256.191 240.506 249.299 242.786 242.943C245.199 236.158 247.238 229.105 247.533 221.864Z",
  fill: "#473B1E"
});

var _ref194 = /*#__PURE__*/React.createElement("path", {
  d: "M200.628 397.038C200.628 397.038 199.582 404.36 197.759 406.72C197.142 407.524 196.042 408.516 195.291 409.938C194.165 412.164 194.782 415.489 195.613 417.313C196.042 418.251 195.586 418.251 196.579 418.546C199.475 419.431 202.586 417.929 203.819 415.14C204.517 413.585 205.107 411.52 205.241 408.892C205.563 402.241 207.628 398.862 207.628 398.862L200.628 397.038Z",
  fill: "#F7A491"
});

var _ref195 = /*#__PURE__*/React.createElement("path", {
  d: "M232.461 400.391C232.461 400.391 233.104 408.651 232.595 411.333C232.3 412.781 230.718 415.731 231.468 417.072C232.193 418.413 233.024 418.762 233.024 418.762L251.796 419.057C252.816 419.083 252.145 418.413 251.314 417.823C249.973 416.831 248.873 416.187 244.556 414.095C244.287 413.961 243.242 413.318 242.893 413.076C241.954 412.513 241.016 411.601 240.211 410.716C238.87 409.214 238.736 401.947 238.736 401.947L232.461 400.391Z",
  fill: "#F7A491"
});

var _ref196 = /*#__PURE__*/React.createElement("path", {
  d: "M247.131 290.679C247.131 290.679 249.49 304.088 247.935 312.857C246.38 321.653 238.924 403.073 238.924 403.073L230.638 403.528C230.638 403.528 228.894 369.523 229.216 364.777C229.538 360.057 231.978 352.119 231.978 352.119L231.147 324.657L241.606 288.587L247.131 290.679Z",
  fill: "#C39367"
});

var _ref197 = /*#__PURE__*/React.createElement("path", {
  d: "M222.78 287.863C222.78 287.863 216.263 297.652 214.708 305.778C213.152 313.877 215.861 338.817 212.857 349.437C211.248 355.176 205.107 364.08 204.168 371.508C203.23 378.937 199.582 398.407 199.582 398.407L207.869 400.043L227.124 351.422L242.223 307.467L246.085 284.833L222.78 287.863Z",
  fill: "#CAA480"
});

var _ref198 = /*#__PURE__*/React.createElement("path", {
  d: "M228.063 232.135C228.063 232.135 219.427 231.599 216.022 235.3C212.616 239.027 223.611 268.42 224.228 273.14C224.845 277.86 221.063 290.437 221.063 290.437C221.063 290.437 241.364 294.514 247.157 290.679C247.157 290.679 247.774 256.674 247.157 253.295C246.54 249.916 241.364 236.185 240.104 234.817C238.844 233.476 228.063 232.135 228.063 232.135Z",
  fill: "#E04E39"
});

var _ref199 = /*#__PURE__*/React.createElement("path", {
  d: "M230.933 220.604C230.933 220.604 230.879 220.845 230.798 221.301C230.423 223.366 228.921 230.258 227.929 232.135C226.722 234.415 232.086 241.709 237.235 240.824C238.763 240.556 235.948 234.12 236.082 233.45C236.35 232.135 236.698 230.365 237.047 228.542C237.262 227.523 237.449 226.477 237.664 225.485C238.227 222.696 238.656 220.416 238.656 220.416L230.933 220.604Z",
  fill: "#F7A491"
});

var _ref200 = /*#__PURE__*/React.createElement("path", {
  d: "M230.825 221.301C230.906 220.872 230.959 220.604 230.959 220.604L238.683 220.416C238.683 220.416 238.227 222.696 237.69 225.485C237.503 226.45 237.288 227.496 237.101 228.515C235.921 228.327 234.66 227.764 233.4 226.665C232.032 225.485 231.147 224.036 230.611 222.508C230.691 222.025 230.772 221.623 230.825 221.301Z",
  fill: "#F47458"
});

var _ref201 = /*#__PURE__*/React.createElement("path", {
  d: "M236.135 203.092C236.135 203.092 232.488 202.663 230.208 205.613C227.929 208.563 225.461 217.654 231.147 222.616C236.805 227.577 242.41 221.972 243.242 216.018C244.073 210.092 244.395 202.878 236.135 203.092Z",
  fill: "#F7A491"
});

var _ref202 = /*#__PURE__*/React.createElement("path", {
  d: "M244.931 215.938C244.261 217.252 243.107 217.976 242.383 217.574C241.659 217.145 241.632 215.751 242.303 214.436C242.973 213.122 244.126 212.398 244.851 212.801C245.548 213.23 245.601 214.624 244.931 215.938Z",
  fill: "#F7A491"
});

var _ref203 = /*#__PURE__*/React.createElement("path", {
  d: "M236.537 202.126C236.537 202.126 231.683 210.789 228.197 211.191C224.71 211.593 224.255 216.206 224.255 216.206C224.255 216.206 225.488 205.613 228.948 203.548C232.407 201.483 236.537 202.126 236.537 202.126Z",
  fill: "#473B1E"
});

var _ref204 = /*#__PURE__*/React.createElement("path", {
  d: "M204.383 413.719C199.877 414.551 196.874 411.896 195.318 409.938C194.165 412.164 193.602 415.516 194.46 417.34C195.211 418.949 197.383 418.922 199.073 418.976C200.869 419.029 202.291 418.037 203.176 416.482C203.605 415.731 204.034 414.819 204.383 413.719Z",
  fill: "#473B1E"
});

var _ref205 = /*#__PURE__*/React.createElement("path", {
  d: "M242.866 413.076C237.905 414.336 234.231 413.478 232.166 412.647C231.63 414.149 230.932 416.026 231.308 417.099C231.764 418.439 232.407 418.734 232.997 418.734C237.529 418.842 249.624 419.003 253.084 419.056C253.567 419.056 253.835 418.493 253.513 418.118C252.655 417.125 243.242 413.29 242.866 413.076Z",
  fill: "#473B1E"
});

var _ref206 = /*#__PURE__*/React.createElement("path", {
  d: "M229.109 213.363C229.404 214.891 228.814 216.313 227.848 216.5C226.856 216.715 225.837 215.615 225.542 214.087C225.247 212.558 225.837 211.137 226.802 210.949C227.795 210.735 228.841 211.807 229.109 213.363Z",
  fill: "#F7A491"
});

var _ref207 = /*#__PURE__*/React.createElement("path", {
  d: "M212.321 217.735C212.321 217.735 224.523 230.822 226.32 236.078C228.144 241.361 224.55 248.897 219.615 249.219C214.681 249.541 203.659 225.995 203.659 225.995L212.321 217.735Z",
  fill: "#E04E39"
});

var _ref208 = /*#__PURE__*/React.createElement("path", {
  d: "M215.643 58.0313L201.886 61.0349C198.587 61.759 195.315 59.6672 194.591 56.3686L193.304 50.4687C192.58 47.1701 194.672 43.8983 197.97 43.1742L211.728 40.1706C215.027 39.4465 218.298 41.5383 219.022 44.8369L220.31 50.7369C221.034 54.0355 218.942 57.3072 215.643 58.0313Z",
  fill: "#CAA480"
});

var _ref209 = /*#__PURE__*/React.createElement("path", {
  d: "M194.725 53.124L188.825 62.6712L197.863 58.7826L194.725 53.124Z",
  fill: "#CAA480"
});

var _ref210 = /*#__PURE__*/React.createElement("path", {
  d: "M201.376 50.4691L203.682 49.9059C203.682 49.9059 206.096 47.09 206.016 46.2855C205.935 45.5077 205.077 43.9791 205.506 43.6841C205.908 43.3891 206.82 43.0137 207.651 43.8719C208.268 44.5155 208.51 47.2777 208.805 47.4118C208.992 47.4923 210.333 47.1973 211.299 46.9827C211.942 46.8218 212.586 47.0632 213.015 47.5459C213.31 47.8677 213.31 48.3773 213.042 48.7259L212.613 49.2623L213.149 49.7182C213.551 50.04 213.578 50.63 213.256 51.0322L212.908 51.4345L213.256 51.6759C213.712 51.9977 213.766 52.6413 213.39 53.0704L213.095 53.3922L213.176 53.4727C213.498 53.8481 213.471 54.3845 213.149 54.7331L212.827 55.0549L206.713 56.5567C206.15 56.6908 205.533 56.7176 204.97 56.6104L202.744 56.7713C202.502 56.7981 202.288 56.6372 202.234 56.3958L201.001 51.0322C200.947 50.7909 201.108 50.5495 201.376 50.4691Z",
  fill: "#623B2A"
});

var _ref211 = /*#__PURE__*/React.createElement("path", {
  d: "M367.191 0.613937C354.855 2.92027 346.005 10.912 347.427 18.5015C348.124 22.2828 351.262 25.2596 355.767 26.9759L352.844 39.0708L361.747 28.4241C364.992 28.8263 368.586 28.7459 372.287 28.0486C384.623 25.7423 393.473 17.7506 392.052 10.1611C390.657 2.59846 379.528 -1.66558 367.191 0.613937Z",
  fill: "#CAA480"
});

var _ref212 = /*#__PURE__*/React.createElement("path", {
  d: "M361.533 17.268C363.437 21.2102 368.157 22.8729 372.1 20.9689C376.042 19.0648 377.705 14.3448 375.801 10.4026C373.897 6.46039 369.177 4.79768 365.234 6.70175C361.319 8.60582 359.656 13.3258 361.533 17.268Z",
  fill: "#623B2A"
});

var _ref213 = /*#__PURE__*/React.createElement("path", {
  d: "M373.038 13.1382C374.057 15.2568 373.172 17.7777 371.054 18.7968C368.935 19.8158 366.414 18.9309 365.395 16.8122L373.038 13.1382Z",
  fill: "#EFEFEF"
});

var _ref214 = /*#__PURE__*/React.createElement("path", {
  d: "M405.514 156.856L399.132 154.04L397.684 158.465L395.565 157.767L397.791 151.036L404.12 153.798L405.756 148.596L411.575 151.036L413.989 145.914L416 146.852L412.702 153.906L407.15 151.599L405.514 156.856Z",
  fill: "#CAA480"
});

var _ref215 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_100_2",
  x1: 273.879,
  y1: 37.6163,
  x2: 313.781,
  y2: 37.6163,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB9A2B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E65925"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_100_2",
  x1: 150.301,
  y1: -13.258,
  x2: 117.259,
  y2: 18.5546,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_100_2",
  x1: 195.165,
  y1: 33.3398,
  x2: 162.122,
  y2: 65.1522,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_100_2",
  x1: 191.862,
  y1: 29.9087,
  x2: 158.819,
  y2: 61.7214,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_100_2",
  x1: 188.41,
  y1: 26.3248,
  x2: 155.368,
  y2: 58.1371,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_100_2",
  x1: 157.64,
  y1: -5.63655,
  x2: 124.597,
  y2: 26.1759,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_100_2",
  x1: 177.324,
  y1: 14.8096,
  x2: 144.282,
  y2: 46.6219,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_100_2",
  x1: 178.448,
  y1: 15.9758,
  x2: 145.406,
  y2: 47.788,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_100_2",
  x1: 177.998,
  y1: 15.5096,
  x2: 144.955,
  y2: 47.3217,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_100_2",
  x1: 173.272,
  y1: 10.6014,
  x2: 140.229,
  y2: 42.414,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_100_2",
  x1: 157.341,
  y1: -5.94613,
  x2: 124.298,
  y2: 25.8661,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9CD55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5065,
  stopColor: "#659C52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#287F50"
})));

function SvgImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 420,
    viewBox: "0 0 416 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.dc51a79a5261136d9bf975983e794a6d.svg";
export { ForwardRef as ReactComponent };